import React from 'react';

export default function VrBadge({ ucc_type }) {
    if (ucc_type === "22") {
        return <button type="button" className="btn-360deg"><span>360도</span></button>;
    } else {
        return null;
    }
}
